export default "__VITE_ASSET__CIRW3q9C__"